import { Route } from "@angular/router";
import { Permissions } from "../../access/shared/authorization/permissions";
import { BillingComponent } from "./billing.component";

export const BillingRouting: Route = { 
    path: 'billing',
    component: BillingComponent,
     data: {
        'role': [
            Permissions.ROLE_FACTURATION,
        ],
        breadcrumb: "Facturation"
    }
};
